<template>
    <div class="modal fade" id="serverAddModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered  w-[700px] ">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5">Add New Server</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body ">
                        <div class="float-left w-1/2 px-2 pb-2 modal-item">
                            Server Name
                            <input v-model="modemName" placeholder="Input modem name" type="text"
                                class="form-control shadow-none rounded-0 text-black">
                        </div>
                        <div class="float-left w-1/2 px-2 pb-2 modal-item">
                            Server URL
                            <input v-model="domain" placeholder="Input domain" type="text"
                                class="form-control shadow-none rounded-0 text-black">
                        </div>
                        <div class="float-left w-1/2 px-2 pb-2 modal-item">
                            Country
                            <v-select v-model="country" :items="countryList" placeholder="Select country"
                                variant="outlined" density="compact" rounded="0" class=""></v-select>
                        </div>
                        <div class="float-left w-1/2 px-2 pb-2 modal-item">
                            ISP
                            <v-select v-model="isp" :items="ispList" placeholder="Select ISP" variant="outlined"
                                density="compact" rounded="0" class=""></v-select>
                        </div>
                        <div class="float-left w-1/2 px-2 pb-2 modal-item">
                            City
                            <input v-model="city" placeholder="Input city" type="text"
                                class="form-control shadow-none rounded-0 text-black">
                        </div>
                        <div class="float-left w-1/2 px-2 pb-2 modal-item">
                            Server Type
                            <v-select v-model="selectedModemType" :items="modemTypes" density="compact"
                                variant="outlined" placeholder="Select Server type" rounded="0"
                                style="padding-top: 0px;padding-bottom: 0px;">
                            </v-select>
                        </div>
                        <div v-if="selectedModemType !== 'PROPROXYUI'" class="float-left w-1/2 px-2 pb-2 modal-item">
                            Username
                            <input v-model="username" placeholder="Input username" type="text"
                                class="form-control shadow-none rounded-0 text-black">
                        </div>
                        <div class="float-left w-1/2 px-2 pb-2 modal-item">
                            {{ selectedModemType === 'PROPROXYUI' ? 'API token (box Settings)' : 'Password' }}
                            <input v-model="password" :placeholder="selectedModemType === 'PROPROXYUI' ? 'API token' : 'Input password'" type="text"
                                class="form-control shadow-none rounded-0 text-black">
                        </div>
                        <div v-if="selectedModemType === 'PROXYSMART'" class="float-left w-1/2 px-2 pb-2 modal-item">
                            <label class="flex items-center gap-2">
                                <input type="checkbox" v-model="isIpv6" class="form-check-input shadow-none"
                                    style="height: 20px; width: 20px;" />
                                IPv6 <span class="text-xs text-gray-500">(Proxysmart only)</span>
                            </label>
                        </div>
                        <div class="float-left w-1/2 px-2 pb-2 modal-item">
                            <label class="flex items-center gap-2">
                                <input type="checkbox" v-model="couponsDisabled" class="form-check-input shadow-none"
                                    style="height: 20px; width: 20px;" />
                                Disable coupons
                            </label>
                        </div>
                        <template v-if="selectedModemType === 'PROXYSMART' || selectedModemType === 'X_PROXY' || selectedModemType === 'XPROXY_NEW_2PORT'">
                            <div class="float-left w-1/2 px-2 pb-2 modal-item">
                                HTTP port range start
                                <input v-model.number="httpPortStart" :placeholder="selectedModemType === 'PROXYSMART' ? '8001' : selectedModemType === 'XPROXY_NEW_2PORT' ? '50001' : '40001'" type="number" min="1024" max="65535"
                                    class="form-control shadow-none rounded-0 text-black">
                            </div>
                            <div v-if="selectedModemType !== 'XPROXY_NEW_2PORT'" class="float-left w-1/2 px-2 pb-2 modal-item">
                                SOCKS5 port range start
                                <input v-model.number="socksPortStart" :placeholder="selectedModemType === 'PROXYSMART' ? '5001' : '41001'" type="number" min="1024" max="65535"
                                    class="form-control shadow-none rounded-0 text-black">
                            </div>
                            <div class="float-left w-full px-2 pb-2 modal-item text-xs text-gray-500"><template v-if="selectedModemType === 'XPROXY_NEW_2PORT'">SOCKS5 is always the HTTP port + 1000. Add Port on the Proxies page suggests the next free pair from here.</template><template v-else>Add Port on the Proxies page suggests the next free HTTP/SOCKS5 pair from here, skipping ports already on the server.</template></div>
                        </template>
                        <template v-if="selectedModemType === 'XPROXY_NEW' || selectedModemType === 'XPROXY_NEW_2PORT'">
                            <div class="float-left w-full px-2 pb-2 modal-item">
                                <label class="flex items-center gap-2">
                                    <input type="checkbox" v-model="usingVps" class="form-check-input shadow-none"
                                        style="height: 20px; width: 20px;" />
                                    Using VPS <span class="text-xs text-gray-500">(a VPN is enabled with the box's "Enable tunnel to VPS" switch on, and VPN files are downloaded with the VPS IP)</span>
                                </label>
                            </div>
                            <div class="float-left w-1/2 px-2 pb-2 modal-item">
                                WireGuard port (modem position 1)
                                <input v-model.number="vpnWgPort" placeholder="5400" type="number" min="1" max="65535"
                                    class="form-control shadow-none rounded-0 text-black">
                            </div>
                            <div class="float-left w-1/2 px-2 pb-2 modal-item">
                                OpenVPN port (modem position 1)
                                <input v-model.number="vpnOvpnPort" placeholder="5500" type="number" min="1" max="65535"
                                    class="form-control shadow-none rounded-0 text-black">
                            </div>
                            <div v-if="selectedModemType === 'XPROXY_NEW'" class="float-left w-1/2 px-2 pb-2 modal-item">
                                Selling port range start (HTTP+SOCKS)
                                <input v-model.number="sellingPortStart" placeholder="5001" type="number" min="1024" max="65535"
                                    class="form-control shadow-none rounded-0 text-black">
                            </div>
                            <div v-if="selectedModemType === 'XPROXY_NEW'" class="float-left w-1/2 px-2 pb-2 modal-item text-xs text-gray-500 flex items-end pb-3">Add Port on the Proxies page suggests the next free port from here.</div>
                            <div class="float-left w-full px-2 pb-2 modal-item text-xs text-gray-500">Position 1 uses exactly these ports ({{ vpnWgPort || 0 }} / {{ vpnOvpnPort || 0 }}), position 2 the next ones ({{ (vpnWgPort || 0) + 1 }} / {{ (vpnOvpnPort || 0) + 1 }}), and so on. Saving a change restarts the VPN service on the box; about a minute later every enabled VPN on it is switched off and on again automatically, and customers need to download their VPN file again.</div>
                        </template>
                        <ProProxyUiBoxSettings v-if="selectedModemType === 'PROPROXYUI'" v-model="boxSettings" :domain="domain" :username="username" :password="password" />
                        <ServerFeaturesBox v-model="features" v-model:max-speed="maxSpeed" :server-type="selectedModemType" />
                        <div class="float-left w-full px-2 pb-2 modal-item">
                            Notes
                            <textarea v-model="notes" class="form-control shadow-none !leading-5 rounded-0 text-black" />
                        </div>
                        <div class="clear-both"></div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" :disabled="buttonDisableFlag" class="btn btn-primary"
                        @click="createServer">Create</button>
                </div>
            </div>
        </div>
    </div>
</template>



<script setup>
import ServerFeaturesBox from './ServerFeaturesBox.vue';
import ProProxyUiBoxSettings from './ProProxyUiBoxSettings.vue';
import { ref, defineEmits } from "vue";

import { useAdminServerStore } from "@/stores"
import { watchEffect } from "vue";

const adminServerStore = useAdminServerStore()

const modemName = ref("");
const domain = ref("");
const country = ref("");
const city = ref("");
const isp = ref("");
const username = ref("");
const password = ref("");
const notes = ref("");
const selectedModemType = ref("X_PROXY");
const modemTypes = ref(["X_PROXY", "XPROXY_NEW", "XPROXY_NEW_2PORT", "PROXYSMART", "PROPROXYUI"]);
const isIpv6 = ref(false);
const couponsDisabled = ref(false);
const features = ref({});   // Features box: empty = every default
const maxSpeed = ref(null);   // Mbps shown to customers, null = no cap
const usingVps = ref(false);   // XPROXY_NEW only
const vpnWgPort = ref(5400);
const vpnOvpnPort = ref(5500);
const sellingPortStart = ref(5001);
const httpPortStart = ref(null);
const socksPortStart = ref(null);
const boxSettings = ref({});   // ProProxyUI: read from the box, changes written back on save
const emit = defineEmits(['inInput', 'submit'])
const buttonDisableFlag = ref(false)


const countryList = ref([])
const ispList = ref([])
const createServer = () => {
    // Call your function to add the values
    // For example:
    const server = {
        modemName: modemName.value,
        domain: domain.value,
        country: country.value,
        city: city.value,
        isp: isp.value,
        username: username.value,
        password: password.value,
        modemType: selectedModemType.value,
        notes: notes.value,
        is_ipv6: isIpv6.value,
        coupons_disabled: couponsDisabled.value,
        os_spoof_disabled: features.value.os_spoofing === false,   // kept in step with the Features box
        features: features.value,
        max_speed_mbps: maxSpeed.value,
        using_vps: ['XPROXY_NEW', 'XPROXY_NEW_2PORT'].includes(selectedModemType.value) && usingVps.value === true,
        vpn_wg_port: vpnWgPort.value || null,
        vpn_ovpn_port: vpnOvpnPort.value || null,
        selling_port_start: sellingPortStart.value || null,
        http_port_start: httpPortStart.value || null,
        socks_port_start: socksPortStart.value || null,
        box_settings: selectedModemType.value === 'PROPROXYUI' && Object.keys(boxSettings.value || {}).length ? boxSettings.value : undefined,
    };
    buttonDisableFlag.value = true
    // Here you can call another function to handle the server creation
    adminServerStore.createServer(server).then(()=>{
        buttonDisableFlag.value=false
        emit('close');

    })
};


watchEffect(async () => {
    countryList.value = await adminServerStore.getCountryList()
    if (countryList.value.length > 0) {
        country.value = countryList.value[0]
    }
}, [])

watchEffect(async () => {
    if (country.value) {
        ispList.value = await adminServerStore.getISPLIst(country.value)
        if (ispList.value.length > 0) {
            isp.value = ispList.value[0]
        }
    }
}, [country.value])


</script>

<style scoped>
.clear-both {
    clear: both;
}
</style>
